import * as Yup from "yup";
import { UserRoleActions } from "../../enums/UserRolesEnum";

const ToggleStatus = [UserRoleActions.ALLOW];
const CheckData = [UserRoleActions.EDIT, UserRoleActions.VIEW];
const TUCheckData = [UserRoleActions.EDIT, UserRoleActions.REVIEW];
const TPCheckData = [
  UserRoleActions.DATA_INPUT,
  UserRoleActions.MANAGER_REVIEW,
  UserRoleActions.ARCHIVED_VIEW,
  UserRoleActions.ARCHIVED_EDIT,
];
const TMCheckData = [
  UserRoleActions.EDIT,
  UserRoleActions.VIEW,
  UserRoleActions.INTERNAL_APPROVAL,
];
export const PanelData = [
  {
    key: "1",
    title: "Dashboard",
    options: ToggleStatus,
    mainPannelSelected: false,
    selectedOptions: [],
  },
  {
    key: "2",
    title: "CRM",
    mainPannelSelected: false,
    multiPannel: [
      {
        key: "21",
        title: "Trucking & Material",
        options: TMCheckData,
        selectedOptions: [],
        path: "/app/trucking-material",
      },
      {
        key: "22",
        title: "Owner Operator",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/owner-operator",
      },
    ],
    selectedOptions: false,
    options: CheckData,
  },
  {
    key: "3",
    title: "Databases",
    mainPannelSelected: false,
    multiPannel: [
      {
        key: "31",
        title: "Customer Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/customer-database",
      },
      {
        key: "36",
        title: "Job Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/job-database",
      },
            {
        key: "34",
        title: "Quarry Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/quarry-finder-tool",
      },
      {
        key: "35",
        title: "Material Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/material-database",
      },
      {
        key: "32",
        title: "Owner Operator Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/twisted-nail",
      },
      {
        key: "33",
        title: "CDL Driver Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/truck-driver-database",
      },
    ],
    selectedOptions: false,
  },
  {
    key: "4",
    mainPannelSelected: false,
    multiPannel: [
      {
        key: "41",
        options: [
          "Edit",
          "View",
          "Delete"
        ],
        path: "/app/dispatch-jobs",
        selectedOptions: ["Edit", "View", "Delete"],
        title: "Request Dispatch"
      },
      {
        key: 42,
        options: [
          "Edit",
          "View",
          "Delete"
        ],
        path: "/app/dispatch-tool",
        selectedOptions: ["Edit",
          "View",
          "Delete"],
        title: "Dispatch Tool"
      },
      {
        key: "43",
        options: [
          "Edit",
          "View",
          "Delete"
        ],
        path: "/app/dispatch-archive",
        selectedOptions: ["Edit",
          "View",
          "Delete"],
        title: "Dispatch Archive"
      }
    ],
    options: [
      "Edit",
      "View",
      "Delete"
    ],
    selectedOptions: [
      "Edit",
      "View",
      "Delete"
    ],
    title: "Operations",
  },
  {
    key: "5",
    title: "Finance",
    options: CheckData,
    mainPannelSelected: false,
    multiPannel: [
      {
        key: "51",
        title: "Ticket Upload",
        options: TUCheckData,
        selectedOptions: [],
        path: "/app/ticket-upload",
      },
      {
        key: "52",
        title: "Ticket Processing",
        options: TPCheckData,
        selectedOptions: [],
        path: "/app/ticket-processing",
      },
      {
        key: "53",
        title: "Invoice Management",
        options: CheckData,
        selectedOptions: [],
        path: "/app/invoiceManagement",
      },
      {
        key: "59",
        title: "Lien Process",
        options: CheckData,
        selectedOptions: [],
        path: "/app/lien-tool",
      },
      {
        key: "57",
        title: "Project Analysis",
        options: CheckData,
        selectedOptions: [],
        path: "/app/projectAnalysis",
      },
    ],
    selectedOptions: false,
  },
  {
    key: "6",
    title: "Settings",
    options: ToggleStatus,
    mainPannelSelected: false,
    multiPannel: [
      {
        key: "60",
        title: "Bid Tool Configuration",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/bid-tool-configuration",
      },
      {
        key: "61",
        title: "Rule Engine",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/rule-engine",
      },
      {
        key: "62",
        title: "Manage Roles",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/manage-roles",
      },
      {
        key: "63",
        title: "System Users",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/system-users",
      },
      {
        key: "64",
        title: "Sales People",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/salesPerson",
      },
      {
        key: "65",
        title: "System Settings",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/system-settings",
      },
      {
        key: "66",
        title: "Restore Data",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/restoreData",
      },
      {
        key: "67",
        title: "Image Database",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/imageDatabase",
      },
      {
        key: "69",
        title: "Documents",
        options: ToggleStatus,
        selectedOptions: [],
        path: "/app/documents",
      },
    ],
    selectedOptions: false,
  },
];

export const newValidationSchema = Yup.object().shape({
  roleName: Yup.string().required("Role Name is required"),
});
